import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { LanguageProvider } from "./context/LanguageContext";

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;

const root = createRoot(document.getElementById("root"));
//redeploy
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: window.location.origin, // Callback-URL
        }}
      >
        <App />
      </Auth0Provider>
    </LanguageProvider>
  </React.StrictMode>
);

reportWebVitals();
